import React from 'react';
import { ArrowLeft, Bell, Volume2, VolumeX, RefreshCw, Clock } from 'lucide-react';

export const POSHeader = ({
  viewMode, tableInput, settings, pendingOrders, soundEnabled,
  setSoundEnabled, loadAllData, currentTime, resetOrder, setViewMode, t
}) => {
  return (
    <header className="h-16 bg-slate-950 border-b border-slate-800 flex items-center justify-between px-6 shrink-0" data-testid="pos-header">
      <div className="flex items-center gap-4">
        {viewMode !== 'dashboard' && (
          <button
            onClick={() => { setViewMode('dashboard'); resetOrder(); }}
            className="p-2 bg-slate-800 rounded-lg hover:bg-slate-700"
            data-testid="header-back-btn"
          >
            <ArrowLeft size={20} />
          </button>
        )}
        <div>
          <h1 className="text-lg font-black">{settings?.restaurant_name || t.title}</h1>
          <p className="text-xs text-slate-500 font-bold uppercase tracking-wider">
            {viewMode === 'menu' ? (tableInput ? `${t.table} ${tableInput}` : t.newOrder) : t.subtitle}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        {pendingOrders.length > 0 && (
          <div className="flex items-center gap-2 px-3 py-1.5 bg-amber-500/20 border border-amber-500/50 rounded-lg animate-pulse" data-testid="pending-orders-badge">
            <Bell size={16} className="text-amber-400" />
            <span className="text-amber-400 font-bold text-sm">{pendingOrders.length} {t.pending}</span>
          </div>
        )}
        <button
          onClick={() => setSoundEnabled(!soundEnabled)}
          className={`p-2 rounded-lg ${soundEnabled ? 'bg-emerald-500/20 text-emerald-400' : 'bg-slate-800 text-slate-500'}`}
          title={soundEnabled ? t.soundOn : t.soundOff}
          data-testid="sound-toggle"
        >
          {soundEnabled ? <Volume2 size={20} /> : <VolumeX size={20} />}
        </button>
        <button onClick={loadAllData} className="p-2 bg-slate-800 rounded-lg hover:bg-slate-700" title={t.refresh} data-testid="refresh-btn">
          <RefreshCw size={20} />
        </button>
        <div className="flex items-center gap-2 px-4 py-2 bg-slate-800 rounded-lg">
          <Clock size={16} className="text-slate-500" />
          <span className="font-mono font-bold">{currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
        </div>
      </div>
    </header>
  );
};
